<div class="my-scorecard">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._9295_MY_SCORECARDS | translate"
        [isLoading]="state?.pending?.reload"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [refreshButtonTooltip]="_i18n._11174_RESET_CARD | translate"
        [expandButtonTooltip]="
            _isExpanded === false
                ? (_i18n._11176_EXPAND_CARD | translate)
                : (_i18n._11175_COLLAPSE_CARD | translate)
        "
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        [hasExpandAction]="state.pending.hasData"
        (expandAction)="_onExpandClick()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-scorecard-card--no-data">
            <h2 class="my-scorecard-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>

    <button
        class="ml-2 cmps-button--sm p-1 scorecard-launch-button"
        *ngIf="_isExpanded === true"
        cmpsButton
        (click)="_launchScorecard()"
    >
        <cmps-icon svgIcon="launch"></cmps-icon>
        <span cmpsButtonLabel>{{
            _i18n._9946_LAUNCH_SCORECARDS | translate
        }}</span>
    </button>

    <ng-container
        *ngIf="
            _isExpanded === false &&
            state.pending.hasData &&
            state.scorecardData
        "
    >
        <div class="insight-component-item-slider">
            <cmps-card-header-row-component
                [cardHeaderLabel]="
                    (state?.scorecardData?.scorecardSubHeader
                        ?.supergroupLabel || '') +
                    '<span class=\'non-bold\'> ' +
                    (state?.scorecardData?.scorecardSubHeader
                        ?.supergroupValue || '') +
                    '</span>'
                "
            ></cmps-card-header-row-component>
            <cmps-scorecard-sub-header
                [superGroupLabel]="
                    state?.scorecardData?.scorecardSubHeader?.supergroupLabel
                "
                [superGroupValue]="
                    state?.scorecardData?.scorecardSubHeader?.supergroupValue
                "
                [timePeriod]="state?.scorecardData?.headerRowData?.periodDate"
                [disabled]="
                    state?.scorecardData?.scorecardSubHeader?.isDisabled
                "
                [options]="state?.periodOptions"
                [selected]="state?.selectedPeriodType?.periodTypeName"
                (selectedAction)="_onPeriodTypeChange($event)"
            ></cmps-scorecard-sub-header>
            <cmps-scorecard-score-container
                [hasCategory]="state.scorecardData?.scCategory"
            >
                <cmps-scorecard-score-section
                    cmps-scorecard-score-section
                    [adjustScoreData]="state.scorecardData?.adjustScoreData"
                    [trendData]="state.scorecardData?.trendData"
                    [launchScoreCardLabel]="
                        _i18n._9980_LAUNCH_SCORECARD | translate
                    "
                    [launchTrendLabel]="_i18n._11184_LAUNCH_TREND | translate"
                    (trendAction)="_onTrendAction()"
                    (selectedAction)="_onSelectAction()"
                ></cmps-scorecard-score-section>
                <cmps-scorecard-category
                    *ngIf="state.scorecardData?.scCategory"
                    cmps-scorecard-category
                    [categoryColor]="state.scorecardData?.scCategory.color"
                    [categoryLabel]="state.scorecardData?.scCategory.label"
                    [categoryValueLabel]="state.scorecardData?.scCategory.value"
                ></cmps-scorecard-category>
            </cmps-scorecard-score-container>
            <cmps-scorecard-trend-section
                [previousScoreLabel]="_i18n._11187_PREVIOUS_SCORE | translate"
                [previousScore]="state.scorecardData?.trendData?.previousScore"
                [percentChangeLabel]="_i18n._11186___CHANGE | translate"
                [percentChange]="state.scorecardData?.trendData?.trendValue"
                [trendColor]="state.scorecardData?.trendData?.trendColor"
            >
            </cmps-scorecard-trend-section>

            <cmps-scorecard-rank
                *ngIf="state?.scorecardData?.rankData"
                [titleLabel]="state?.scorecardData?.rankData?.titleLabel"
                [data]="state?.scorecardData?.rankData?.data"
            ></cmps-scorecard-rank>
            <cmps-scorecard-bonus
                *ngIf="state?.scorecardData?.bonusData"
                [bonusData]="state?.scorecardData?.bonusData"
            ></cmps-scorecard-bonus>
            <div class="scorecard-banner">
                <span>{{
                    state?.scorecardData?.scorecardSubHeader?.scorecardId
                }}</span>
                <span>{{
                    state?.scorecardData?.scorecardSubHeader?.scorecardValue
                }}</span>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="
            _isExpanded === false && state.selectedScorecardHistory?.length > 1
        "
    >
        <button
            class="slider-button prev"
            (click)="_onPrevSlide()"
            [cmpsTooltipTrigger]="
                _i18n._11188_VIEW_PREVIOUS_SCORECARD | translate
            "
            *ngIf="!state.historyPos?.isAtFirst"
        >
            <cmps-icon svgIcon="arrow-left-drop-circle"></cmps-icon>
        </button>
        <button
            class="slider-button next"
            (click)="_onNextSlide()"
            [cmpsTooltipTrigger]="_i18n._11189_VIEW_NEXT_SCORECARD | translate"
            *ngIf="!state.historyPos?.isAtLast"
        >
            <cmps-icon svgIcon="arrow-right-drop-circle"></cmps-icon>
        </button>
    </ng-container>

    <ng-container *ngIf="_isExpanded === true">
        <cmps-scorecard></cmps-scorecard>
    </ng-container>
</ng-template>
